module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("\n    " + _vm._s(_vm.idLabel) + "\n    "), (_vm.statusIcon !== '') ? _c('i', {
    staticClass: "icon icon-transaction-detail",
    class: _vm.statusIcon
  }) : _vm._e()]), _vm._v(" "), (_vm.inputType === 'number') ? _c('input', {
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "type": "number",
      "disabled": "true"
    },
    domProps: {
      "value": _vm.inputValue
    }
  }) : _c('input', {
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": _vm.inputValue
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38cef30e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38cef30e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/formReadGroupLabelInput.vue
// module id = 2331
// module chunks = 2